import './Share.scss'

import {
	blueskyLink,
	facebookLink,
	linkedInLink,
	mailLink
} from '../../util/share'

import {Icon} from '../ui/Icon'
import React from 'react'
import {style} from '../../util/style'

const styles = style('share', ['link'])

export type ShareType = {
	className?: string
	text?: string
}

type SharePlatformType = 'facebook' | 'bluesky' | 'linkedin' | 'mail'

export const Share: React.FC<ShareType> = ({className, text}) => {
	return (
		<div className={styles().with(className)}>
			{text && <p className={styles('text')}>{text}</p>}
			<div className={styles('row')}>
				<ShareLink platform="mail" />
				<ShareLink platform="facebook" />
				<ShareLink platform="linkedin" />
				<ShareLink platform="bluesky" />
			</div>
		</div>
	)
}

const ShareLink: React.FC<{
	platform: SharePlatformType
}> = ({platform}) => {
	if (!platform) return null

	return (
		<a className={styles.link().mod(platform)} {...SharePlatform({platform})}>
			<Icon icon={platform} />
		</a>
	)
}

const SharePlatform = ({platform}: {platform: SharePlatformType}) => {
	const currentUrl = window.location.href.split(/[?#]/)[0]
	if (!platform) return null

	switch (platform) {
		case 'bluesky':
			return blueskyLink(currentUrl)
		case 'facebook':
			return facebookLink(currentUrl)
		case 'linkedin':
			return linkedInLink(currentUrl)
		case 'mail':
			return mailLink(currentUrl)
	}
}
